import type { ReactNode } from "react";

/**
 * Wrapper for data tables that makes them mobile-friendly with zero changes
 * to the table markup itself — just the `<td>`s need `data-label="…"` attrs
 * (and optionally `data-fullwidth` on a cell that should span the card width,
 * e.g. an actions row).
 *
 * Behaviour (driven by the responsive CSS layer in index.css):
 *   • desktop ≥1025px — renders the table exactly as before
 *   • tablet 769–1024 — `.table-scroll` makes a wide table scroll horizontally
 *   • phone ≤768px    — `.table-cards` turns each <tr> into a stacked card,
 *                       each <td> into a [LABEL][value] row from data-label
 *
 * Usage:
 *   <TableShell empty={rows.length === 0} emptyNode={<p>No invoices yet.</p>}>
 *     <table>…<td data-label="Customer">{c.name}</td>…</table>
 *   </TableShell>
 */
export function TableShell({
  children,
  empty,
  emptyNode,
}: {
  children: ReactNode;
  empty?: boolean;
  emptyNode?: ReactNode;
}) {
  if (empty) {
    return <div className="table-empty">{emptyNode}</div>;
  }
  return <div className="table-cards table-scroll">{children}</div>;
}
